module.exports = __webpack_public_path__ + "img/icon-map.df2ba1c7.svg";